/*
 * @Author: zhaosujuan zhaosujuan@freedodata.com
 * @Date: 2022-10-24 17:14:37
 * @LastEditors: zhaosujuan zhaosujuan@freedodata.com
 * @LastEditTime: 2022-11-02 17:58:37
 * @FilePath: \lyws-official-websit\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import store from '@/store/index';
import { mutChangeDefaultActivePath } from '@/store/mutation-types.js';
import Router from 'vue-router'
import HomePage from '@/components/home'
import Index from '@/components/index/index.vue'
import Solution from '@/components/solution/solution'
import Case from '@/components/case/case'
import AboutUs from '@/components/aboutUs/aboutUs'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      redirect:'/index',
      children:[
        {
          path:'/index',
          name:'Index',
          component:Index
        },
        {
          path:'/solution',
          name:'Solution',
          component:Solution
        },
        {
          path:'/case',
          name:'Case',
          component:Case
        },
        {
          path:'/aboutUs',
          name:'AboutUs',
          component:AboutUs
        }
      ]
    },

  ]
})
router.beforeEach(async (to, from, next) => {
  // 设置header部分的activePath
  store.commit(mutChangeDefaultActivePath, to.path);
  next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js